export const DISEASE_REGION_COLOR = {
  'fill': ' #b3c6df',
  'stroke': '#889EBA'
};

export const FLANKING_COLOR = {
  'fill': '#ececec',
  'stroke': '#D8D9DA'
};

export const BLOCK_COLORS = [
  {
    'fill': '#bbbbbb',
    'stroke': '#7f7f7f'
  },
  {
    'fill': '#085cfc',
    'stroke': '#0153E1'
  },
  {
    'fill': '#ff0404',
    'stroke': '#DC0505'
  },
  {
    'fill': '#f8a004',
    'stroke': '#D48805'
  },
  {
    'fill': '#027d03',
    'stroke': '#016E01'
  }
];

export const SNP_COLORS = [
  {
    'fill': '#ececec',
    'stroke': '#7f7f7f'
  },
  {
    'fill': '#085cfc',
    'stroke': '#0000ac'
  },
  {
    'fill': '#ff0404',
    'stroke': '#DC0505'
  },
  {
    'fill': '#f8a004',
    'stroke': '#D48805'
  },
  {
    'fill': '#027d03',
    'stroke': '#005F00'
  }
];
